const undo = {
    svg: '<svg style="width:1.00rem; height:1.00rem;" viewBox="0 0 16 16"><path d="M5.651 1.2 1.156 5.74l4.416 4.46 1.06-1.049L3.988 6.48h5.937c1.708 0 3.114 1.262 3.3 2.884l.015.182.005.184c0 1.794-1.486 3.25-3.32 3.25H5.3v1.43h4.626c2.636 0 4.774-2.094 4.774-4.68 0-2.585-2.138-4.68-4.774-4.68h-5.99l2.775-2.801z"/></svg>',
};

export { undo as default };
